import * as u from '../utils';

export default () => {
    const swatches = document.querySelectorAll('.attribute-swatches li');
    const activeName = document.querySelector('.attribute-swatches__active-name');

    if (!swatches.length) {
        return;
    }

    const handleSwatchClick = (e) => {
        if (u.hasClass(e.currentTarget, 'inactive')) {
            return;
        }
        const value = e.currentTarget.dataset.value;
        u.removeClass(e.currentTarget.parentNode.childNodes, 'selected');
        u.addClass(e.currentTarget, 'selected');

        const select = e.currentTarget.parentNode.previousSibling;
        select.value = value;
        u.trigger('change', select);

        activeName.innerText = select.options[select.selectedIndex].text;
    };

    for (const el of swatches) {
        el.addEventListener('click', handleSwatchClick);
    }

    jQuery('.variations_form').on('woocommerce_update_variation_values', function () {
        u.addClass(swatches, 'inactive');

        for (const el of swatches) {
            const select = el.parentNode.previousSibling;

            Array.from(select.options).forEach(function (option) {
                if (option.value === el.dataset.value) {
                    u.removeClass(el, 'inactive');
                }
            });
        }
    });
};
